<template>
    <div class="supplyList-adjust">
        <HeaderNav
            header-title="供应单调整"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="content">
            <div class="info-panel">
                <ul>
                    <li class="tit">
                        <div class="row-item-title">
                            <span class="pre-icon materialPlan04"></span>
                            <span class="info">供应单:{{ supply.no }}</span>
                        </div>
                    </li>
                    <li>
                        <span class="pre-icon materialPlan31"></span>
                        <span class="info">接收场站：{{ supply.station_name }}</span>
                    </li>
                    <li>
                        <span class="pre-icon materialPlan09"></span>
                        <span class="info">供应商：{{ supply.supplier_name }}</span>
                    </li>
                    <li>
                        <span class="pre-icon materialPlan06"></span>
                        <span class="info">供应日期：{{ supply.supply_date }}</span>
                    </li>
                    <li>
                        <div class="row-item">
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">物料名称：{{ supply.goods_name }}</span>
                        </div>
                        <div class="row-item">
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">子类：{{ supply.type_name }}</span>
                        </div>
                    </li>
                    <li>
                        <span class="pre-icon materialPlan0"></span>
                        <span class="info">型号：{{ supply.spec_name }}方</span>
                    </li>


                    <li>
                        <span class="pre-icon icon_11"></span>
                        <span class="info">货源地：{{ supply.source_name }}</span>
                    </li>
                    <li>
                        <span class="pre-icon materialPlan02"></span>
                        <span class="info">计量单位:{{ supply.measure_unit }}</span>
                    </li>
                    <li>
                        <span class="pre-icon materialPlan02"></span>
                        <span class="info">已累计毛重:{{ supply.total_gross_weight }}</span>
                    </li>
                </ul>
            </div>
            <div class="adjust">
                <div class="item">
                    <lable>供应量</lable><input type="text" v-model="supply.supply_count">
                </div>
                <div class="item">
                    <label>是否限量</label>
                    <div class="raido-box">
                        <van-radio-group v-model="supply.is_restrict_supply" direction="horizontal" icon-size="14px">
                            <van-radio :name="1">
                                是
                            </van-radio>
                            <van-radio :name="0">
                                否
                            </van-radio>
                        </van-radio-group>
                    </div>
                    <lable>限制重量</lable><input type="text" v-model="supply.restrict_supply_count">
                </div>
                <div class="item">
                    <lable>备注：</lable>
                    <div class="remark">
                        <van-field
                            v-model="supply.remarks"
                            rows="1"
                            autosize
                            type="textarea"
                            placeholder="请输入备注"
                        ></van-field>
                    </div>
                    <!--                    <input type="text" v-model="supply.remarks">-->
                </div>
            </div>
            <div class="sure" @click="handleSure">
                确认
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    name: 'supply-adjust',
    components: {
        HeaderNav,
    },
    data() {
        return {
            supplyId: '',
            supply: {},
        };
    },
    created() {
        this.supplyId = this.$route.query.supplyId;
        this.getInfo();
    },
    methods: {
        getInfo() {
            this.$axios.get(`/interfaceApi/procurement/daily/supply/get/${this.supplyId}`,).then(data => {
                this.supply = data;
            });
        },
        // 确认
        handleSure() {
            const params = {
                id: this.supply.id,
                plan_goods_id: this.supply.plan_goods_id,
                supply_count: this.supply.supply_count,
                is_restrict_supply: this.supply.is_restrict_supply,
                restrict_supply_count: this.supply.restrict_supply_count,
                remarks: this.supply.remarks,
            };
            this.$axios.post('/interfaceApi/procurement/daily/supply/adjust', params).then(data => {
                this.$toast('操作成功');
                this.$router.isBack = 1;
                this.$router.back();
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
.supplyList-adjust
    padding-top 44rpx
    height calc(100% - 44rpx)
    .content
        width 100%;
        height 100%;
        background #EFEFEF
        padding 15rpx;
        .info-panel
            background: #FFFFFF;
            padding 13rpx;
            li
                overflow hidden
                margin-bottom 8rpx
                font-size 14rpx;
                .row-item-title
                    display inline-block
                    width 70%;
                    white-space nowrap
                    font-size 15rpx;
                .row-item-status
                    display inline-block
                    width 30%;
                    text-align right
                    padding-right 10rpx
                    white-space nowrap
                    font-size 12rpx;
                    color #FF6600
                .row-item
                    display inline-block
                    width 50%;
                .pre-icon
                    width 16rpx
                    height 16rpx
                    float left
                    background-size 100% 100%
                    background-repeat no-repeat
                    display inline-block
                    margin 2rpx 10rpx 0 0
                    &.materialPlan0
                        background-image url(./../../../assets/images/icons/icon_gy_5.png)
                    &.materialPlan01
                        background-image url(./../../../assets/images/icons/icon_gy_3.png)
                    &.materialPlan02
                        background-image url(./../../../assets/images/icons/icon_30.png)
                    &.materialPlan03
                        background-image url(./../../../assets/images/icons/icon_6.png)
                    &.materialPlan04
                        background-image url(./../../../assets/images/icons/icon_gy_1.png)
                    &.materialPlan05
                        background-image url(./../../../assets/images/icons/icon_32.png)
                    &.materialPlan06
                        background-image url(./../../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan07
                        background-image url(./../../../assets/images/icons/icon_3.png)
                    &.materialPlan08
                        background-image url(./../../../assets/images/icons/icon_16.png)
                    &.materialPlan09
                        background-image url(./../../../assets/images/icons/icon_gy_8.png)
                    &.materialPlan31
                        background-image url(./../../../assets/images/icons/icon_gy_2.png)
                    &.icon_11
                        background-image url(./../../../assets/images/icons/icon_11.png)
                .info
                    float left
                    width calc(100% - 26rpx)
                &.tit
                    font-size 14rpx
                    color #061F3E
                    display: flex;
                    align-items: center;
        .adjust
            margin-top 15rpx;
            background: #FFFFFF;
            box-shadow: 1px 1px 4rpx 0px rgba(52, 149, 251, 0.35);
            border: 1px solid #F0F0F0;
            .item
                padding 12rpx 15rpx;
                display flex
                align-items center
                justify-content space-between
                label
                    display flex
                    width 70rpx;
                    font-size 16rpx;
                    color #333;
                input
                    box-sizing border-box
                    padding-left 15rpx;
                    width: 243rpx;
                    height: 32rpx;
                    background: #F8F8F8;
                    border-radius: 4rpx;
                    border: 1px solid #D7D7D7;
                &:nth-child(2)
                    display: flex;
                    flex-wrap: wrap;
                    border-top 1px solid #F0F0F0;
                    border-bottom 1px solid #F0F0F0;
                    label
                        width 100%;
                    .raido-box
                        width 100%;
                        margin 10rpx 0;
                        font-size 14rpx;

                .remark
                    width: 243rpx;
        .sure
            margin-top 15rpx;
            width: 100%;
            height: 44rpx;
            background: #5494F3;
            border-radius: 4rpx;
            display flex
            justify-content center
            align-items center
            font-size 14rpx;
            color #fff;
</style>
